import { cn } from '../lib/utils';
import { Input } from './ui/input';

interface SuffixedInputProps {
  id: string;
  value: string;
  suffix: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  'aria-describedby'?: string;
  'aria-invalid'?: boolean;
  onChange: (value: string) => void;
}

/** A numeric field with its unit shown inline — e.g. "70 %" — so the label doesn't have to carry it. */
export function SuffixedInput({
  id,
  value,
  suffix,
  disabled = false,
  placeholder,
  className,
  'aria-describedby': describedBy,
  'aria-invalid': invalid,
  onChange,
}: SuffixedInputProps) {
  return (
    <div className={cn('relative max-w-[180px]', className)}>
      <Input
        id={id}
        inputMode="numeric"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        aria-describedby={describedBy}
        aria-invalid={invalid}
        onChange={(event) => onChange(event.target.value)}
        className="pr-14"
      />
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
        {suffix}
      </span>
    </div>
  );
}
